import React from 'react'
import Home from '../Home/Home'
import About from '../About/About'
import Contact from '../Contact/Contact'
import Header from '../Header/Header'
import Skill from '../Skill/Skill'
import './Profile.css'

function Profile() {
  return (
    <div className='profile-container'>
        <Header/>
        
        <Home/>
        <About/>
        <Skill/>
        <Contact/>
        
        
 
    </div>
  )
}

export default Profile